import { appRoutes } from 'features/app/routes/paths';
import { IdType } from 'ts/IdType';

export const subscriptionPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/subscription/plans`,
    card: `${appRoutes.static.root}/subscription/plans:planId`,
  },
  dynamic: {
    card: (cardId: IdType) => `${appRoutes.static.root}/subscription/plans/${cardId}`,
  },
});